import React from 'react';
import './Services.css';

const Services: React.FC = () => {
  return (
    <section className="services">
      {/* Title in a textbox */}
      <div className="textbox">
        <h1 className="services-title">What We Do</h1>
      </div>
      {/* Container for the two textboxes */}
      <div className="services-container">
        {/* Residential textbox */}
        <div className="textbox">
          <h2>Residential</h2>
          <ul>
            <li>Garden design and maintenance</li>
            <li>Lawn care and landscaping</li>
            <li>Home repair work</li>
            <li>Seasonal cleanups</li>
          </ul>
        </div>
        {/* Commercial textbox */}
        <div className="textbox">
          <h2>Commercial</h2>
          <ul>
            <li>Office park gardening</li>
            <li>Property maintenance contracts</li>
            <li>Irrigation system management</li>
            <li>Horticultural advice</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Services;